(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('lodash'), require('object-browser')) :
	typeof define === 'function' && define.amd ? define(['lodash', 'object-browser'], factory) :
	(global['mongo-query-compiler'] = factory(global._,global.browser));
}(this, (function (_,objectBrowser) { 'use strict';

_ = 'default' in _ ? _['default'] : _;

var $all = function (values, all) {
  if(!_.isArray(all)) {
    all = [all];
  }
  
  return !_.difference(all, values).length;
};

var $elemMatch = function (array, filterer, exists, o, symbolTable, symbolName) {
  if(!_.isFunction(filterer)) {
    filterer = compiler(filterer);
    symbolTable[symbolName] = filterer;
  }
  
  return _.filter(array, filterer).length;
};

var $size = function (array, size) { return array.length === size; };

var arrayNormalizer = function (operations) {
  return _.reduce(operations, function (operations, op, opName) {
    operations[opName] = function (array) {
      var rest = [], len = arguments.length - 1;
      while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];

      if(!_.isArray(array)) {
        array = [array];
      }
      
      rest.unshift(array);
      
      return op.apply(void 0, rest);
    };
    
    return operations;
  }, {});
};

var arrayOps = arrayNormalizer({$all: $all, $elemMatch: $elemMatch, $size: $size});

var $where = function (value, callback, exists, o, symbolTable, symbolName) {
  if(_.isString(callback)) {
    callback = new Function(("return " + callback + ";"));
    symbolTable[symbolName] = callback;
  }
  
  return callback.apply(o, callback.length ? [o, objectBrowser.browser] : []);
};

var freeFormOps = {$where: $where};

var $exists = function (value, testValue, exists) { return exists === testValue; };

var $mod = function (value, testValue) {
  if(!_.isArray(testValue)) {
    testValue = [testValue];
  }
  
  var divisor = testValue[0];
  var remainder = testValue[1];
  
  if(!_.isNumber(divisor) || !_.isNumber(remainder)) {
    throw new Error('divisor and remainder should be numbers');
  }
  
  return value % divisor === remainder;
};

var $regexp = function (value, testValue) { return testValue.test(value); };

var $type = function (value, type) {
  type = 'is' + _.capitalize(type);
  var typer = _[type];
  
  if(!typer) {
    return console.warn('only lodash-based types are supported');
  }
  
  return typer(value);
};

var eq = function (value, testValue) {
  for(var i = 0; i < 2; i++) {
    if(_.isArray(value) && !_.isObject(testValue)) {
      return value.includes(testValue);
    }
    
    var assign;
    (assign = [testValue, value], value = assign[0], testValue = assign[1]);
  }
  
  if(_.isRegExp(testValue)) {
    return testValue.test(value);
  }
  
  return _.isEqual(value, testValue);
};

var $in = function () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  _.each(args, function (arg, idx, args) {
    if(!_.isArray(arg)) {
      args[idx] = [arg];
    }
  });

  var values = args[0];
  var testValues = args[1];
  
  if(!testValues.length) {
    return;
  }
  
  for(var i = 0, leni = values.length; i < leni; i++) {
    for(var j = 0, value = values[i], lenj = testValues.length; j < lenj; j++) {
      var option = testValues[j];
      
      if(_.isRegExp(option) && option.test(value)) {
        break;
      }
      
      if(value === option) {
        break;
      }
      
      if(j === lenj - 1) {
        return false;
      }
    }
  }
  
  return true;
};

var $ne = function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return !eq.apply(void 0, args);
};

var $nin = function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return !$in.apply(void 0, args);
};

var arrayComparator = function (op) {
  return function (values, testValue) {
    if(!_.isArray(values)) {
      values = [values];
    }
    
    for(var i = 0, list = values; i < list.length; i += 1) {
      var value = list[i];

      if(_[op](value, testValue)) {
        return true;
      }
    }
  }; 
};

var $gt = arrayComparator('gt');

var $gte = arrayComparator('gte');

var $lt = arrayComparator('lt');

var $lte = arrayComparator('lte');

var primitiveOps = {$exists: $exists, $mod: $mod, $regexp: $regexp, $type: $type, $eq: eq, $in: $in, $ne: $ne, $nin: $nin, $gt: $gt, $gte: $gte, $lt: $lt, $lte: $lte};

var referencerNormalizer = function (operations) {
  return _.reduce(operations, function (operations, op, opName) {
    operations[opName] = function (value, testValue, exists, o, symbolTable, symbolName) {
      if(!exists) {
        if(['$ne', '$nin'].includes(opName)) {
          return true;
        }
        
        return;
      }
      
      if(_.isPlainObject(testValue)) {
        var $ref = testValue.$ref;
        var flatten = testValue.$flatten;
        if($ref) {
          testValue = objectBrowser.browser(o, $ref, {flatten: flatten});
        }
      }

      return op(value, testValue, exists, o, symbolTable, symbolName);
    };
    
    return operations;
  }, {});  
};

var operations = (function () {
  var operations = _.extend({}, arrayOps, primitiveOps);
  operations = referencerNormalizer(operations);
  return _.extend(operations, freeFormOps);
})();

var evl = function (o, path, opName, testValue, symbolTable, symbolName, flatten) {
  var loperand = objectBrowser.browser(o, path, {exists: true, flatten: flatten});
  var value = loperand.value;
  var exists = loperand.exists;
  return !operations[opName](value, testValue, exists, o, symbolTable, symbolName);
};

var varId_ = _.partial(_.uniqueId, 'v');

var datum = function(value) {
  var varId = varId_();
  this._d[varId] = value;
  return varId;
};

var pather = function (parent, child) {
  if(!parent) {
    return child;
  }
  
  if(!child) {
    return parent;
  }
  
  return parent + '.' + child;
};

var ignoreds = ['$comment'];

var elementals = _.keys(arrayOps).concat(_.keys(freeFormOps), _.keys(primitiveOps));

var logicals = ['$or', '$and', '$nor', '$not'];

var expression = function(parentPath, query, iffer, flatten) {
  var this$1 = this;

  if(query.hasOwnProperty('$flatten')) {
    flatten = !!query.$flatten;
    delete query.$flatten;
  }
  
  _.each(query, function (query, op) {
    if(ignoreds.includes(op)) {
      return;
    }
    
    if(elementals.includes(op)) {
      return this$1.elemental(parentPath, query, op, iffer, flatten);
    } 
    
    if(logicals.includes(op)) {
      return this$1.logical(parentPath, query, op, iffer, flatten);
    } 
    
    var path = pather(parentPath, op);
      
    if(_.isPlainObject(query)) {
      return this$1.expression(path, query, iffer, flatten);
    } 
    
    this$1.elemental(path, query, '$eq', iffer, flatten);
  });
};

var LogicBlock = function LogicBlock(condition, not, or) {
  _.extend(this, {conditions: [], not: not, or: or});
  if(condition) {
    this.add(condition);
  }
};
  
LogicBlock.prototype.add = function add (condition) {
  this.conditions.push({condition: condition, operator: this.or ? '||' : '&&'});
};
  
LogicBlock.prototype.return = function return$1 () {
  var ref = this;
    var conditions = ref.conditions;
    var not = ref.not;
  var first = _.first(conditions);
  var block = '';

  delete first.operator;
    
  for(var i = 0, list = conditions; i < list.length; i += 1) {
    var conditionObj = list[i];

      var condition = conditionObj.condition;
      var operator = conditionObj.operator;
    if(condition instanceof LogicBlock) {
      condition = condition.return();
    }
      
    block += (operator || '') + condition;
  }
    
  if(not) {
    block = "!(" + block + ")";
  }
    
  return block;
};

var Iffer = function Iffer() {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  _.extend(this, {blocks: []});
  (ref = this).start.apply(ref, args);
  var ref;
};
  
Iffer.prototype.start = function start (condition, not, or) {
  var current = new LogicBlock(condition, not, or);
    
  if(this.current) {
    this.add(current);
  }
    
  this.blocks.push(current);
  return _.extend(this, {current: current});
};
  
Iffer.prototype.add = function add (condition) {
  this.current.add(condition);
  return this;
};

Iffer.prototype.group = function group (condition, not, or) {
  return this.start(condition, not, or);
};
  
Iffer.prototype.groupClose = function groupClose () {
  var ref = this;
    var blocks = ref.blocks;
    
  if(!blocks.length) {
    return;
  }
    
  blocks.pop();
  var current = _.last(blocks);
  return _.extend(this, {current: current});
};
  
Iffer.prototype.return = function return$1 (writer) {
  if(this.blocks.length > 1) {
    throw new Error('some groups were not closed');
  }
    
  var code = this.current.return();
  code = "if(" + code + "){return false;}";
    
  return writer ? writer(code) : code;
};

var eqOps = ['$eq', '$ne'];
var objectAcceptors = eqOps.concat('$elemMatch');

var unwindAssessor = function (path, query, op) {
  if(!path && eqOps.includes(op)) {
    return true;
  }
  
  if(_.isPlainObject(query)) {
    if(!query['$ref'] && !objectAcceptors.includes(op)) {
      return true;
    }
  }
};

var elemental = function(path, query, op, iffer_, flatten) {
  var this$1 = this;

  if(unwindAssessor(path, query, op)) {
    return _.each(query, function (query, path_) {
      path_ = pather(path, path_);
      this$1.elemental(path_, query, op, iffer_, flatten);
    });
  }

  if(!path) {
    path = '__self';
  }
  
  var iffer = iffer_;
  var symbolName = this.datum(query);
  var condition = "evl(o, '" + path + "', '" + op + "', d." + symbolName + ", d, '" + symbolName + "', " + flatten + ")";
  
  if(iffer) {
    return iffer.add(condition);
  }
  
  new Iffer(condition).return(this.writer);
};

var negation = [null, true];

var opParamsMap = {
  $or:  [],
  $nor: negation,
  $not: negation,
  $and: [null, false, true]
};

var ifferParamer = function (op) { return opParamsMap[op].slice(); };

var logical = function(path, query, op, iffer_, flatten) {
  var this$1 = this;

  var ifferParams = ifferParamer(op);
  var iffer = iffer_;
  
  if(op === '$not' && !_.isPlainObject(query)) {
    return this.elemental(path, query, '$ne', iffer_, flatten);
  }
  
  if(!iffer) {
    iffer = new (Function.prototype.bind.apply( Iffer, [ null ].concat( ifferParams) ));
  } else {
    iffer.group.apply(iffer, ifferParams);
  }
  
  if(_.isArray(query)) {
    _.each(query, function (query) {
      this$1.expression(path, query, iffer, flatten);
    });
  } else {
    this.expression(path, query, iffer, flatten);
  }
  
  if(!iffer_) {
    iffer.return(this.writer);
  } else {
    iffer.groupClose();
  }
};

var writer = function(code) {
  this._code += code;
};

function Compiler(query) {
  var _d = {};
  
  _.extend(this, {
    _code: '', 
    _d: _d, 
    writer: this.writer.bind(this)
  });
  
  this.expression('', query);
  this.writer('return true;');
  var func = new Function('o', 'd', 'evl', this._code);
  return _.partial(func, _, _d, evl);
}

_.extend(Compiler.prototype, {datum: datum, expression: expression, elemental: elemental, logical: logical, writer: writer});

var compiler = function (query) {
  if(!_.isPlainObject(query)) {
    throw new Error('query must be an object');
  }
  
  return new Compiler(query);
};

return compiler;

})));
